import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquare } from '@fortawesome/free-regular-svg-icons'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { Localize } from "../shared/localize.js";

class WheelsFilters extends React.Component {

  constructor(props) {
    super(props);
  };

  render() {
    var ret = null;

    var brands = [];
    brands.push(
      <option key={"all"} value={""}>{Localize.L("Mostra tutti")}</option>
    );
    brands.push(
      <option key={"separator"} disabled={true} value={""}>----------------</option>
    );
    this.props.brands.forEach((b, i) => {
      brands.push(
        <option key={"brand" + i} value={b}>{b}</option>
      );
    });
    var diameters = [];

    this.props.filters.diameters.forEach((d, i) => {
      var disabled = !this.props.diameters.some((dd) => dd == d.diameter);
      disabled = false;
      diameters.push(
        <a key={"diameter" + i}
          className={"btn " + (d.active ? "  active" : " ") + (disabled ? "  disabled" : " ")} 
          href=""
          style={{ fontSize: "1.5rem", backgroundColor: "transparent", borderColor: "#ddd"}}
          onClick={(e) => this.props.handleChange(e, d.diameter)}
        >
          <span className="fa-layers fa-fw">
            <FontAwesomeIcon icon={faSquare} color="#999" />
            {d.active ? <FontAwesomeIcon icon={faCheck} color="rgb(0, 138, 0)" transform="grow-7 up-4 right-2" /> : null}
          </span>
          &nbsp;{d.diameter}
        </a>
      );
    });

    var steelOrAlloy = [];
    this.props.filters.steelOrAlloy.forEach((d, i) => {
      var disabled = !this.props.filters.values.steelOrAlloy.some((dd) => dd == d.steelOrAlloy);
      disabled = false;
      steelOrAlloy.push(
        <a key={"steelOrAlloy" + i}
          className={"btn " + (d.active ? "  active" : " ") + (disabled ? "  disabled" : " ")}
          href="#"
          style={{ fontSize: "1.5rem", backgroundColor: "transparent", borderColor: "#ddd" }}
          onClick={(e) => this.props.handleChange(e, null, d.steelOrAlloy)}
        >
          <span className="fa-layers fa-fw">
            <FontAwesomeIcon icon={faSquare} color="#999" />
            {d.active ? <FontAwesomeIcon icon={faCheck} color="rgb(0, 138, 0)" transform="grow-7 up-4 right-2" /> : null}
          </span>
          &nbsp;{d.steelOrAlloy}
        </a>
      );
    });

    var chassis = this.props.car.ExtChassis;

    if (((this.props.car.ModelName || "") != "") && ((this.props.car.ExtChassis || "") != "") && (this.props.car.ModelName == this.props.car.ExtChassis)) {
      chassis = "";
    }

    if ((this.props.hideFilters || false)) {
      return "";
    }

    ret = (
      <div className={"wheels-filters"}>
        <div className={"row"} style={{ fontFamily: "PT Sans Narrow"}}>
          <div className="col">
            <div className={"form-group"}>
              <h1><span style={{ color: "#35393d", fontFamily: "PT Sans Narrow" }}>{Localize.L("Cerchi per:")}</span>{this.props.car.ManufacturerName} {Localize.L(this.props.car.ModelName, { Get: 'models', ManufacturerName: this.props.car.ManufacturerName })} {Localize.L(chassis, { Get: 'chassis', ManufacturerName: this.props.car.ManufacturerName })}
                <span style={{ color: "#35393d", fontFamily: "PT Sans Narrow", fontSize: "2.2rem" }}>{this.props.year}</span>
              </h1>
            </div>
          </div>
          <div className="col-sm-auto">
            <div className={"form-group"}>
              <label style={{ fontSize: "18px", display: "block" }}>{Localize.L("Ferro/Lega")}</label>
              <div className="btn-group btn-group-lg">
                {steelOrAlloy}
              </div>
            </div>
          </div>
          <div className="col">
            <div className={"form-group"}>
              <label style={{ fontSize: "18px", display: "block" }}>{Localize.L("Marca cerchi")}</label>
              <select 
                className={"form-control form-control-lg"}
                style={{ fontSize: "1.5rem", height: "34px" }}
                name="brand"
                value={this.props.filters.brand}
                onChange={(e) => this.props.handleChange(e)}
              >
                {brands}
              </select>
            </div>
          </div>
          <div className="col">
            <label style={{ fontSize: "18px", display: "block" }}>{Localize.L("Diametro dei cerchi")}</label>
            <div className="btn-group btn-group-lg">
              {diameters}
            </div>
          </div>
        </div>
      </div>
    );

    return ret;
  }


}

export { WheelsFilters }